module.exports = __webpack_public_path__ + "static/media/iconArrow.311ad0e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/Icons/iconArrow.svg
// module id = 1135
// module chunks = 0